const translations = {
  nav_about: "Nosotros",
  nav_services: "Servicios",
  nav_method: "Método",
  nav_library: "Biblioteca",
  nav_contact: "Contacto",
  nav_login: "Iniciar sesión",
  nav_register: "Registrarse",
  nav_my_profile: "Mi perfil",
  nav_availability: "Estado de disponibilidad",
  nav_processes: "Mis procesos",
  nav_edit: "Editar información",
  nav_privacy: "Política de privacidad",
  nav_logout: "Cerrar sesión",
  nav_company_account: "Cuenta empresarial",
  nav_professional_account: "Cuenta profesional",
  hero_badge: "International Placement",
  hero_title_1: "Agencia de selección internacional que conecta empresas europeas con profesionales cualificados.",
  hero_subtitle: "Especializados en procesos de incorporación en Alemania, Suiza, Bélgica, Austria y Países Bajos. Trabajamos con empresas que necesitan reforzar sus equipos y con profesionales que buscan oportunidades reales en Europa.",
  hero_markets: "Alemania · Suiza · Países Bajos · Austria · Bélgica",
  hero_cta_talent: "Buscar talento",
  hero_cta_explore: "Explorar oportunidades",
  hero_social_proof: "",
  audience_companies_title: "Para Empresas",
  audience_companies_point1: "Acceso a perfiles cualificados del sector construcción y otros sectores estratégicos.",
  audience_companies_point2: "Proceso de preselección detallado y personalizado.",
  audience_companies_point3: "Modelo de trabajo a éxito.",
  audience_companies_point4: "Garantía de sustitución durante los primeros 30 días.",
  audience_companies_cta: "Buscar talento",
  audience_professionals_title: "Para Profesionales",
  audience_professionals_point1: "Oportunidades reales en Alemania, Suiza, Bélgica, Austria y Países Bajos.",
  audience_professionals_point2: "Proceso transparente y acompañamiento durante la selección.",
  audience_professionals_point3: "Acceso a empresas europeas con demanda activa de personal cualificado.",
  audience_professionals_cta: "Explorar oportunidades",
};

export default translations;